import $ from 'jquery';

export default class InteractiveContentCards {
    constructor() {
        $('.secinteractivecontentcards__card').on('click', function () {
            var index = '#tab-' + $(this).attr('id').slice(33);
            $('#secinteractivecontentcards__output .container-10').hide();
            $(index).show();
        });
    }
}
